import './App.scss';
import 'animate.css';

function App() {
  return (
    <div className="wedding-invite">
      <section className="hero animate__animated animate__fadeInDown">
        <h1>Ritanya & Akshay</h1>
        <p>We're getting married!</p>
        <span className="date">November 27, 2025</span>
      </section>
      <section className="couple animate__animated animate__fadeInLeft">
        <img src="./bride.jpg" alt="Bride" className="photo" />
        <img src="./groom.jpg" alt="Groom" className="photo" />
        <div>
          <h2>Our Story</h2>
          <p>
            From college sweethearts to lifelong partners, join us as we celebrate our love.
          </p>
        </div>
      </section>
      <section className="details animate__animated animate__fadeInRight">
        <h2>Event Details</h2>
        <ul>
          <li><strong>Ceremony:</strong> 3:00 PM, Poornima Convention Center (<a href="https://maps.app.goo.gl/3XTEHEzet7drvRTA6" target="_blank" rel="noopener noreferrer">View on Google Maps</a>)</li>
          <li><strong>Reception:</strong> 5:00 PM, Poornima Convention Center</li>
        </ul>
      </section>
      <section className="gallery animate__animated animate__zoomIn">
        <h2>Gallery</h2>
        <div className="photos">
          <img src="/gallery1.jpg" alt="Gallery 1" />
          <img src="/gallery2.jpg" alt="Gallery 2" />
          <img src="/gallery3.jpg" alt="Gallery 3" />
        </div>
      </section>
      <footer>
        <p>With love, Ritanya & Akshay</p>
      </footer>
    </div>
  );
}

export default App;
